<ui-grid [data]="data$ | async"
         [loading]="loading$ | async"
         [selectable]="false">
    <ui-grid-header [search]="true">
    </ui-grid-header>
    <ui-grid-column [sortable]="true"
                    [searchable]="true"
                    [primary]="true"
                    [title]="'credential_stores_resource_name' | translate"
                    property="name"
                    width="100%">
    </ui-grid-column>
    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
